<template>
    <div class="vc-item-avatar">
        <div :style="{'background-image': 'url(' +  item.image(50) + ')'}" class="vc-item-avatar__image"></div>
        <template v-if="showOverlay && !item.notPlayable">
            <div :style="$musicContainerOverlayStyle" class="vc-item-avatar__shadow"></div>
            <div class="vc-item-avatar__play">
                <base-play-svg
                        :backgroundColor="$itemPlayButtonStyle.background"
                        :iconColor="$itemPlayButtonStyle.color"
                        :paused="isPlaying"
                        :small="true"
                        @click="isPlaying ? item.pause() : item.play()"></base-play-svg>
            </div>
        </template>
    </div>
</template>

<script>
    import Configure from '../../mixins/configure'

    import BasePlaySvg from '../base/base-play-svg.vue'

    export default {
        name: "item-avatar",
        props: {
            item: {
                type: Object,
                required: true
            },
            active: {
                type: Boolean,
                default: false,
            },
        },
        components: {
            BasePlaySvg,
        },
        mixins: [Configure],
        computed: {
            showOverlay() {
                return !(this.item.type === "collection") && (this.active || this.isPlaying || this.isPaused);
            },
            playlistManager() {
                return this.$store.state.playlistManager;
            },
            isPlaying() {
                return (this.playlistManager.isPlaying(this.item) && this.playerActive);
            },
            isPaused() {
                return (this.playlistManager.isPlaying(this.item) && !this.playerActive);
            },
            playerActive() {
                return this.$store.state.player.playing;
            },
        }
    }
</script>

<style lang="scss" scoped>
    .vc-item-avatar {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 5px;
        width: 52px;
        height: 52px;

        &__shadow {
            opacity: 0.6;
        }

        &__shadow, &__play {
            position: absolute;
        }

        &__shadow, &__image {
            border-radius: 5px;
            width: inherit;
            height: inherit;
        }
    }
</style>
